import moment from "moment";
import { ColDef } from "ag-grid-community";
import { ColumnTypeEnum, createGroupColumn } from "../../../components";

export const columnDefinitions: ColDef[] = [
  createGroupColumn("Date", "date", ColumnTypeEnum.Date, {
    sort: "asc",
    valueGetter: (params) => {
      const data = params.data ?? params.node?.data ?? params.node?.aggData;
      if (data) {
        return moment(data.date).format("YYYY-MM-DD");
      }
      return undefined;
    },
    maxWidth: 150,
  }),

  createGroupColumn("Book", "book", ColumnTypeEnum.Text, {
    width: 150,
    menuTabs: ["generalMenuTab"],
  }),

  createGroupColumn(
    "Underlying",
    "underlyingInstrument.symbol",
    ColumnTypeEnum.Logo,
    {
      menuTabs: ["generalMenuTab"],
      width: 150,
      valueGetter: (params) => {
        if (params?.data?.underlyingInstrument?.instrumentType === "Future") {
          return params.data.underlyingInstrument.name;
        } else {
          return params?.data?.underlyingInstrument?.symbol;
        }
      },
    }
  ),

  createGroupColumn("Position Group", "positionGroup", ColumnTypeEnum.Text, {
    width: 150,
    menuTabs: ["generalMenuTab"],
  }),

  createGroupColumn("Category", "category", ColumnTypeEnum.Text, {
    maxWidth: 150,
    menuTabs: ["generalMenuTab"],
  }),

  createGroupColumn("Strategy", "strategy", ColumnTypeEnum.Text, {
    hide: true,
    menuTabs: ["generalMenuTab"],
  }),

  createGroupColumn("Tags", "tags", ColumnTypeEnum.Tags, {
    hide: true,
    menuTabs: ["generalMenuTab"],
    valueGetter: (params) => {
      const data = params.data ?? params.node?.data ?? params.node?.aggData;
      if (!data) {
        return undefined;
      }
      return data.tags;
    },
  }),

  createGroupColumn("Symbol", "instrument.symbol", ColumnTypeEnum.Logo, {
    hide: true,
  }),

  createGroupColumn("Summary", "type", ColumnTypeEnum.Text, { maxWidth: 150 }),
  createGroupColumn("Description", "description", ColumnTypeEnum.Text, {
    minWidth: 150,
  }),
  createGroupColumn("Value", "value", ColumnTypeEnum.Currency, {
    cellRendererParams: {
      showDirection: true,
    },
    aggFunc: "sum",
    maxWidth: 220,
  }),

  createGroupColumn("Fees", "fees", ColumnTypeEnum.Currency, {
    cellRendererParams: {
      showDirection: true,
    },
    aggFunc: "sum",
    maxWidth: 220,
  }),

  createGroupColumn("Currency", "currency", ColumnTypeEnum.Text, {
    maxWidth: 130,
  }),

  createGroupColumn("Id", "cashflowId", ColumnTypeEnum.Text, {
    hide: true,
    menuTabs: ["generalMenuTab"],
    aggFunc: "none",
  }),
];
